'use client';
import { useEffect, useState } from 'react';
import AppModal from '../AppModal';
import AppButton from '../AppButton';
import './style.css';

interface IAppDeleteWarningProps {
  title?: string;
  message?: string;
  model?: any;
  onConfirmDelete?: (_id: string) => void;
  onCancel: () => void;
}

const AppDeleteWarning = ({ model, title, message, onConfirmDelete, onCancel }: IAppDeleteWarningProps) => {
  const [openModal, setOpenModal] = useState<boolean>(model ? true : false);

  useEffect(() => {
    setOpenModal(model ? true : false);
  }, [model]);

  const handleDelete = () => {
    onConfirmDelete && onConfirmDelete(model?.id || '');
  };

  return (
    <AppModal
      open={openModal}
      onHide={() => {
        setOpenModal(false);
        onCancel();
      }}
      header={title || 'Deseja excluir o registro?'}
    >
      <p>{message || 'Você tem certeza que deseja excluir este registro?'}</p>
      <div className="app-delete-warning-actions">
        <AppButton label="Deletar" className="app-delete-warning-delete-btn" onClick={handleDelete} />
        <AppButton
          label="Cancelar"
          className="app-delete-warning-cancel-btn"
          onClick={() => {
            setOpenModal(false);
            onCancel();
          }}
        />
      </div>
    </AppModal>
  );
};

export default AppDeleteWarning;
